import { useEffect, useState } from "react";
import { Table, Space } from "antd";
import { useRequest } from "ahooks";
import { setting as settingService } from "@/services";
import { useAuthContext } from "@/components/auth/AuthProvider";
import WordStockAddButton from "./WordStockAddButton";
import WordStockEditButton from "./WordStockEditButton";
import WordStockDeleteButton from "./WordStockDeleteButton";

import styles from "./index.module.less";

function WordStock() {
  const [version, setVersion] = useState(Date.now());
  const auth = useAuthContext();
  const {
    data = { total: 0, results: [] },
    loading,
    run,
  } = useRequest(
    (params, token) => {
      return settingService.listWordStock(params, token);
    },
    {
      manual: true,
    }
  );

  useEffect(() => {
    if (auth) {
      run(
        {
          version,
          page: 1,
          page_size: 50,
        },
        auth.token
      );
    }
  }, [run, auth, version]);

  const columns = [
    {
      title: "序号",
      key: "num",
      width: 100,
      render: (text, record, index) => `${index + 1}`,
    },
    {
      title: "敏感词",
      dataIndex: "content",
    },
    {
      title: "操作",
      key: "operate",
      width: 120,
      render: (record) => (
        <Space>
          <WordStockEditButton
            wordId={record.id}
            token={auth.token}
            callback={setVersion}
          />
          <WordStockDeleteButton
            wordId={record.id}
            token={auth.token}
            callback={setVersion}
          />
        </Space>
      ),
    },
  ];
  return (
    <div className={styles.publication}>
      <div className="table-toolbar">
        <div className="left">
          <WordStockAddButton token={auth.token} callback={setVersion} />
        </div>
        <div className="right"></div>
      </div>
      <Table
        rowKey="id"
        size="middle"
        columns={columns}
        dataSource={data.results}
        loading={loading}
        pagination={false}
      />
    </div>
  );
}

export default WordStock;
